import templateUrl from './subscribe.html';

export const subscribeComponent = {
	templateUrl,

	controller: class SubscribeComponent {
		constructor() {
			'ngInject';

		}

		$onInit() {
			
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/subscribe/subscribe.component.js